import type { ComponentPropsWithoutRef } from 'react';

type Props = Omit<ComponentPropsWithoutRef<'svg'>, 'xmlns' | 'viewBox' | 'className'>;

// https://thenounproject.com/search/?q=warning&i=976488
// Warning by Gregor Cresnar from the Noun Project
const Icon = (props: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="15 15 70 70" className="icon" {...props}>
    <path d="M52.64,21a3,3,0,0,0-5.28,0L16.08,75.23a3.5,3.5,0,0,0,3,5.25H80.89a3.5,3.5,0,0,0,3-5.25Zm.86,48.43a2,2,0,0,1-2,2h-3a2,2,0,0,1-2-2v-3a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Zm0-10.75a1.75,1.75,0,0,1-1.75,1.75h-3.5a1.75,1.75,0,0,1-1.75-1.75V41.23a1.75,1.75,0,0,1,1.75-1.75h3.5a1.75,1.75,0,0,1,1.75,1.75Z" />
  </svg>
);

export default Icon;
